import React, { useState, useEffect, useRef } from 'react'
import CountUp from 'react-countup';
import "./GameCounter.css"

const Counter = () => {
  const [startCounting, setStartCounting] = useState(false)
  const statsRef = useRef(null)     

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCounting(true)
        }
      },
      {
        threshold: 0.3, 
        rootMargin: '0px'
      }
    )

    if (statsRef.current) {
      observer.observe(statsRef.current)
    }

    return () => {
      if (statsRef.current) {
        observer.unobserve(statsRef.current)
      }
    }
  }, [])

  return (
    <section id="gamestats" className="gamemainclass" ref={statsRef}>
        <div className="container">
            <div className="statsBox">
                <span>
                    <CountUp 
                        start={0} 
                        end={startCounting ? 12 : 0} 
                        duration={2.5} 
                        suffix="+"
                        separator="" 
                    />
                </span>
                <p>Years in Game Development</p>
            </div>
            <div className="statsBox">
                <span>
                    <CountUp 
                        start={0} 
                        end={startCounting ? 75 : 0} 
                        duration={2.5} 
                        suffix="+"
                    />
                </span>
                <p>Clients Worldwide</p>
            </div>
            <div className="statsBox">
                <span>
                    <CountUp 
                        start={0} 
                        end={startCounting ? 350 : 0} 
                        duration={2.5} 
                        suffix="+"
                    />
                </span>
                <p>Games & Apps Delivered</p>
            </div>
          </div>
    </section>
  )
}

export default Counter;